import { IS_SERVER } from "@/constants";
export const getCookie = (name) => {
    if (IS_SERVER)
        return undefined;
    const cookie = document === null || document === void 0 ? void 0 : document.cookie.split(";").find((c) => c.trim().startsWith(name + "="));
    if (cookie) {
        return cookie.split("=")[1];
    }
    return undefined;
};
export const setCookie = (name, value, days) => {
    if (IS_SERVER)
        return undefined;
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};domain=${window.location.hostname};path=/`;
};
export const eraseCookie = (name) => {
    if (IS_SERVER)
        return undefined;
    document.cookie = `${name}=;domain=${window.location.hostname};path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
};
